// extracted by mini-css-extract-plugin
export var addToCartButton = "_ta-b";
export var arrowButtonContainer = "_ta-9";
export var arrowButtonIcon = "_ta-a";
export var carouselArrowButton = "_ta-6";
export var carouselElementContainer = "_ta-1";
export var left = "_ta-7";
export var productDisplayCarouselContainer = "_ta-0";
export var productTileContainer = "_ta-2";
export var productTileImage = "_ta-4";
export var productTileImageContainer = "_ta-3";
export var productTileTitle = "_ta-5";
export var right = "_ta-8";
export var sliderOverflow = "_ta-c";